module.exports = __webpack_public_path__ + "img/pin-intermarche.9d8a7690.svg";